module.exports = __webpack_public_path__ + "static/img/MockOnboardingInviteMembers.f1ac64d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MockOnboardingInviteMembers.png
// module id = qd0v
// module chunks = 1